import styled from 'styled-components';

export const SignInContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 1em;
`;

export const SignInTitle = styled.h2`
  margin: 10px 0;
`;

export const ButtonsBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
